import { connect } from 'react-redux';
import { actions as composerPopoverActions } from '~/composer-popover';
import ComposePage from './components/ComposePage';

export default connect(
  (state) => ({
    queryParams: state.router?.location?.search,
    isLoading: state.campaignsList.isLoading,
  }),

  (dispatch) => ({
    initComposer: ({ shouldResetComposerData, post }) => {
      dispatch(
        composerPopoverActions.handleCreatePostClick({
          shouldResetComposerData,
          post,
          cta: 'publish-extension-createAPost-1',
        })
      );
    },
    onComposerCreateSuccess: () => {
      window.close();
    },
    onConfirmDismissComposer: () => {
      window.close();
    },
  })
)(ComposePage);
